import { AxiosResponse } from 'axios';
import { decodeJwt } from '@/shared/helpers/helpers';
import { HttpClientFactory } from '@/shared/services';
import TermsOfUseLoadingException from '@/shared/models/exceptions/TermsOfUseLoadingException';

class TermsOfUseService {
  private readonly UPDATE_TC_URL = '/api/v1/auth/users/update-tc-version';

  private readonly TERMS_BASE_URL = '/ui-assets/rainbow-ui/files';

  public getBaseUrl = () => this.TERMS_BASE_URL;

  public loadTerms = (): Promise<any> => HttpClientFactory.baseClient
    .get(`${this.TERMS_BASE_URL}/TCs/index.json`)
    .then((res: AxiosResponse) => res.data);

  public loadTermsFile = (path: string): Promise<any> => HttpClientFactory.baseClient
    .get(`${this.TERMS_BASE_URL}${path}`)
    .then((res: AxiosResponse) => res.data);

  public updateTCVersion = (version: string) => HttpClientFactory
    .build()
    .put(`${this.UPDATE_TC_URL}/${version}`, {});

  public getUpdatedTermsVersion = (eulafileIdentifier: string, updatedVersion?: string): Promise<string | undefined> => {
    if (updatedVersion) {
      return Promise.resolve(updatedVersion);
    }

    if (!eulafileIdentifier) {
      throw new TermsOfUseLoadingException('Missing eula identifier');
    }

    return this.loadTerms().then(tcs => tcs?.[eulafileIdentifier]?.version);
  };

  public needToSignTermOfUse = (jwt: string, termOfUseVersion?: string) : boolean => {
    const decodedJwt = decodeJwt(jwt);

    if (!termOfUseVersion || !decodedJwt) {
      throw new Error('TERMS_ERROR');
    }

    const tcSignedVersion = decodedJwt && JSON.parse(decodedJwt.properties);

    return termOfUseVersion !== tcSignedVersion?.TC_VERSION;
  };
}

export const termsService = new TermsOfUseService();
